// extracted by mini-css-extract-plugin
export var inline = "_w4-0";